import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';

import { OnDestroyMixin, untilComponentDestroyed } from '@w11k/ngx-componentdestroyed';
import { TaskList, Task } from '../tasks.types';
import { LegacyTasksTabService } from '../services/tasks.service';

@Component({
  selector: 'link-tasks',
  templateUrl: './link-tasks.component.html',
  styleUrls: ['./link-tasks.component.scss'],
})
export class LinkTasksComponent extends OnDestroyMixin implements OnInit {
  public linkedTaskForm: UntypedFormGroup;
  public isLoading: boolean;
  onlyTasks: Task[];
  task: Task;
  taskLists: TaskList[];
  linked_from_task_id: number;
  linked_to_task_id: number;

  get isSaveBtnDisabled(): boolean {
    return this.isLoading || this.linkedTaskForm.pristine || this.linkedTaskForm.invalid;
  }

  constructor(
    private readonly matDialogRef: MatDialogRef<LinkTasksComponent>,
    private readonly formBuilder: UntypedFormBuilder,
    private _tasksService: LegacyTasksTabService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    super();
  }

  ngOnInit(): void {
    this.onlyTasks = this.data?.onlyTasks;
    this.task = this.data?.task;
    this.taskLists = this.data?.taskLists;
    this.linked_from_task_id = this.data?.linked_from_task_id;
    this.buildForm();
  }

  private buildForm(): void {
    this.linkedTaskForm = this.formBuilder.group({
      task_list_id: [''],
      linked_from_task_id: [''],
    });
  }

  onChangeSelectedTaskList($event): void {
    this.getTasks($event.value);
  }

  private getTasks(taskListId?: number): void {
    this._tasksService
      .getTasks(taskListId, null, {}, '', false)
      .pipe(untilComponentDestroyed(this))
      .subscribe((data: any) => {
        const flattenTasks = this._tasksService.flattenTasks(data);
        this.onlyTasks = flattenTasks?.filter((t) => t.task_type === 'task' || t?.task_type === 'key_date');
      });
  }

  // Function attached to debounce-click directive to flag the button's disable state.
  public isDebounceLoading(isLoading: boolean): boolean {
    return (this.isLoading = isLoading);
  }

  public discard(): void {
    this.matDialogRef.close();
  }

  public save(): void {
    this.matDialogRef.close({ linked_from_task_id: this.linkedTaskForm.get('linked_from_task_id').value });
  }
}
